import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const VALID_PREFERENCES = ['system', 'light', 'dark'];

function getSystemMode() {
  if (typeof window === 'undefined') return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function normalizePreference(preference) {
  return VALID_PREFERENCES.includes(preference) ? preference : 'system';
}

function resolveMode(preference) {
  const normalized = normalizePreference(preference);
  if (normalized === 'system') return getSystemMode();
  return normalized;
}

const useThemeStore = create(
  persist(
    (set) => ({
      preference: 'system', // 'system' | 'light' | 'dark'
      hasHydrated: false,
      setPreference: (preference) => set({ preference: normalizePreference(preference) }),
      cyclePreference: () =>
        set((state) => {
          const order = VALID_PREFERENCES;
          const current = normalizePreference(state.preference);
          const next = order[(order.indexOf(current) + 1) % order.length];
          return { preference: next };
        }),
      setHasHydrated: (hasHydrated) => set({ hasHydrated }),
    }),
    {
      name: 'theme-preference',
      partialize: (state) => ({ preference: state.preference }),
      onRehydrateStorage: () => (state) => {
        if (state && !VALID_PREFERENCES.includes(state.preference)) {
          state.setPreference('system');
        }
        state?.setHasHydrated(true);
      },
    }
  )
);

export { normalizePreference, resolveMode, VALID_PREFERENCES };
export default useThemeStore;
